/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Patients.Web.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  GetPharmaciesV2Params,
  PharmacyListItemApiOutContract,
  ProblemDetails
} from '../pwrdbyQuickMDPatientsWebApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Searches pharmacies in ScriptSure by business name, scoped to the patient's zip code for proximity ordering.
 */
export const getPharmaciesV2 = (
    params?: GetPharmaciesV2Params,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PharmacyListItemApiOutContract[]>(
      {url: `https://patient-web-api.api.quick.md/api/v2/pharmacies`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPharmaciesV2InfiniteQueryKey = (params?: GetPharmaciesV2Params,) => {
    return [
    'infinite', `https://patient-web-api.api.quick.md/api/v2/pharmacies`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetPharmaciesV2QueryKey = (params?: GetPharmaciesV2Params,) => {
    return [
    `https://patient-web-api.api.quick.md/api/v2/pharmacies`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPharmaciesV2InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPharmaciesV2>>>, TError = ProblemDetails>(params?: GetPharmaciesV2Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPharmaciesV2InfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPharmaciesV2>>> = ({ signal }) => getPharmaciesV2(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPharmaciesV2InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPharmaciesV2>>>
export type GetPharmaciesV2InfiniteQueryError = ProblemDetails


export function useGetPharmaciesV2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmaciesV2>>>, TError = ProblemDetails>(
 params: undefined |  GetPharmaciesV2Params, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPharmaciesV2>>,
          TError,
          Awaited<ReturnType<typeof getPharmaciesV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmaciesV2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmaciesV2>>>, TError = ProblemDetails>(
 params?: GetPharmaciesV2Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPharmaciesV2>>,
          TError,
          Awaited<ReturnType<typeof getPharmaciesV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmaciesV2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmaciesV2>>>, TError = ProblemDetails>(
 params?: GetPharmaciesV2Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Searches pharmacies in ScriptSure by business name, scoped to the patient's zip code for proximity ordering.
 */

export function useGetPharmaciesV2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmaciesV2>>>, TError = ProblemDetails>(
 params?: GetPharmaciesV2Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPharmaciesV2InfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Searches pharmacies in ScriptSure by business name, scoped to the patient's zip code for proximity ordering.
 */
export const prefetchGetPharmaciesV2InfiniteQuery = async <TData = Awaited<ReturnType<typeof getPharmaciesV2>>, TError = ProblemDetails>(
 queryClient: QueryClient, params?: GetPharmaciesV2Params, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPharmaciesV2InfiniteQueryOptions(params,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPharmaciesV2QueryOptions = <TData = Awaited<ReturnType<typeof getPharmaciesV2>>, TError = ProblemDetails>(params?: GetPharmaciesV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPharmaciesV2QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPharmaciesV2>>> = ({ signal }) => getPharmaciesV2(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPharmaciesV2QueryResult = NonNullable<Awaited<ReturnType<typeof getPharmaciesV2>>>
export type GetPharmaciesV2QueryError = ProblemDetails


export function useGetPharmaciesV2<TData = Awaited<ReturnType<typeof getPharmaciesV2>>, TError = ProblemDetails>(
 params: undefined |  GetPharmaciesV2Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPharmaciesV2>>,
          TError,
          Awaited<ReturnType<typeof getPharmaciesV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmaciesV2<TData = Awaited<ReturnType<typeof getPharmaciesV2>>, TError = ProblemDetails>(
 params?: GetPharmaciesV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPharmaciesV2>>,
          TError,
          Awaited<ReturnType<typeof getPharmaciesV2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmaciesV2<TData = Awaited<ReturnType<typeof getPharmaciesV2>>, TError = ProblemDetails>(
 params?: GetPharmaciesV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Searches pharmacies in ScriptSure by business name, scoped to the patient's zip code for proximity ordering.
 */

export function useGetPharmaciesV2<TData = Awaited<ReturnType<typeof getPharmaciesV2>>, TError = ProblemDetails>(
 params?: GetPharmaciesV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPharmaciesV2QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Searches pharmacies in ScriptSure by business name, scoped to the patient's zip code for proximity ordering.
 */
export const prefetchGetPharmaciesV2Query = async <TData = Awaited<ReturnType<typeof getPharmaciesV2>>, TError = ProblemDetails>(
 queryClient: QueryClient, params?: GetPharmaciesV2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPharmaciesV2QueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPharmaciesV2SuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPharmaciesV2>>, TError = ProblemDetails>(params?: GetPharmaciesV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPharmaciesV2QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPharmaciesV2>>> = ({ signal }) => getPharmaciesV2(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPharmaciesV2SuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPharmaciesV2>>>
export type GetPharmaciesV2SuspenseQueryError = ProblemDetails


export function useGetPharmaciesV2Suspense<TData = Awaited<ReturnType<typeof getPharmaciesV2>>, TError = ProblemDetails>(
 params: undefined |  GetPharmaciesV2Params, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmaciesV2Suspense<TData = Awaited<ReturnType<typeof getPharmaciesV2>>, TError = ProblemDetails>(
 params?: GetPharmaciesV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmaciesV2Suspense<TData = Awaited<ReturnType<typeof getPharmaciesV2>>, TError = ProblemDetails>(
 params?: GetPharmaciesV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Searches pharmacies in ScriptSure by business name, scoped to the patient's zip code for proximity ordering.
 */

export function useGetPharmaciesV2Suspense<TData = Awaited<ReturnType<typeof getPharmaciesV2>>, TError = ProblemDetails>(
 params?: GetPharmaciesV2Params, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPharmaciesV2SuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPharmaciesV2SuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPharmaciesV2>>>, TError = ProblemDetails>(params?: GetPharmaciesV2Params, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPharmaciesV2InfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPharmaciesV2>>> = ({ signal }) => getPharmaciesV2(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPharmaciesV2SuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPharmaciesV2>>>
export type GetPharmaciesV2SuspenseInfiniteQueryError = ProblemDetails


export function useGetPharmaciesV2SuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmaciesV2>>>, TError = ProblemDetails>(
 params: undefined |  GetPharmaciesV2Params, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmaciesV2SuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmaciesV2>>>, TError = ProblemDetails>(
 params?: GetPharmaciesV2Params, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmaciesV2SuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmaciesV2>>>, TError = ProblemDetails>(
 params?: GetPharmaciesV2Params, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Searches pharmacies in ScriptSure by business name, scoped to the patient's zip code for proximity ordering.
 */

export function useGetPharmaciesV2SuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmaciesV2>>>, TError = ProblemDetails>(
 params?: GetPharmaciesV2Params, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmaciesV2>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPharmaciesV2SuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




